import React from 'react'
import { Button } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { FiEdit3 as EditIcon } from 'react-icons/fi'
import { getImageFromProperty, getMonthStringList } from 'src/utils'
import { subscriptionContainer } from 'src/models'
import { LinkWithLocale, ImageComponent } from 'src/views/components'
import { pageNames } from 'src/routes/pathParams'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import { SubscriptionModal } from '../SubscriptionModal'
import ProductDetails from '../ProductDetails'
import { i18nTranslate } from 'src/utils'
import { getFrequenciesBasedOnAdminConfig } from 'src/deps/NuskinSubscriptionDeps'
import DeleteItemModal from '../SubscriptionNextOrders/DeleteItemModal'
import { SKIP_DELETE_MODAL_TYPES } from 'src/static/fixtures/flexibleSubscription'

@observer
class ProductCard extends React.Component {
  @observable showSubscriptionModal = false
  @observable confirmDeleteModal = false

  /**
   * Generates a product link URL based on the provided link options.
   *
   * Constructs the URL using the product slug or ID, variant,
   * and other provided link options.
   */
  getItemLink = linkOptions => {
    const { data = {} } = this.props || {}
    const { isBundle = false, bundle = {} } = linkOptions || {}
    const productSlug = data?.itemInfo?.[0]?.properties?.slug || ''
    let skuVariant = data?.properties?.slug || ''
    const variantLabel =
      data?.properties?.variantLabel ||
      data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.variantLabel
    if (!skuVariant) {
      skuVariant = data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug || ''
    }

    const productID = isBundle
      ? bundle?.productId
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId

    const productOrSlugId = productSlug ? productSlug : productID
    const categoryId = data?.properties?.categoryId || ''
    let productQueryParams = new URLSearchParams()

    if (variantLabel) {
      const slugVariant =
        data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug ||
        data?.itemInfo?.[0]?.skus?.[0]?.id
      productQueryParams.append('variant', slugVariant)
    }
    productQueryParams = productQueryParams.toString()
    const url =
      `${pageNames.product}/${productOrSlugId}` +
      (productQueryParams ? `?${productQueryParams}` : '')
    return url
  }

  /**
   * Handles opening the manage order tab in the subscription container.
   */
  handleManageOrder = selectedLabel => {
    subscriptionContainer.subscriptionSelectedDate = selectedLabel
    this.props?.handleTabChange('nextOrder')
  }
  handleSkipItem = () => {
    console.log('handleSkipItem')
  }

  /**
   * Toggles showing the subscription modal by setting
   * showSubscriptionModal to the opposite of its current value.
   */
  togglesSubscriptionModal = () => {
    this.showSubscriptionModal = !this.showSubscriptionModal
  }
  handleQuantityChange = () => {
    console.log('handleQuantityChange')
  }

  handleCancelItem = subscriptionId => {
    this.confirmDeleteModel = false
    this.props.handleCancelSingle(subscriptionId)
  }
  handleDeleteClose = () => {
    this.confirmDeleteModal = false
    this.showSubscriptionModal = true
  }
  handleDeleteItem = () => {
    if (this.checkIfCanSkipOrDelete(SKIP_DELETE_MODAL_TYPES.DELETE)) {
      this.showSubscriptionModal = false
      this.confirmDeleteModal = true
    }
  }
  checkIfCanSkipOrDelete = (modalType = '') => {
    if (this.props.canSkipOrDelete) {
      return true
    } else {
      this.props.toggleScanInfoModal(modalType)
      return false
    }
  }

  render() {
    const { data, index } = this.props
    let skuType = data?.itemInfo?.[0]?.skus?.[0]?.type || ''
    const bundleItems = subscriptionContainer.getBundleData(data)
    const isBundle = bundleItems?.isBundle || false
    const productImage = getImageFromProperty(
      isBundle
        ? bundleItems?.bundle?.[0]?.skuProperties
        : data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    )
    const _bundle = {
      ...bundleItems,
      ...(bundleItems?.skuProperties || {}),
      ...(bundleItems?.bundle?.[0]?.skuProperties || {}),
    }
    let productInfo = isBundle
      ? _bundle
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    const skuDetails = isBundle
      ? bundleItems?.bundle?.[0]?.skuProperties
      : data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    const url = this.getItemLink({ isBundle, bundleItems })
    const skuId = isBundle
      ? bundleItems.bundle?.[0].productId
      : data?.itemInfo?.[0]?.skus?.[0]?.id || ''
    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    const totalValue = data?.itemInfo?.[0]?.totalValue || {}
    const unitValue = data?.itemInfo?.[0]?.unitValue || {}
    const { originalPrice = '', priceAfterDiscount = '' } = unitValue
    const { priceFacets = '' } = totalValue

    const isStarterKit =
      data?.itemInfo?.[0]?.properties?.isstarterkit || '' === 'true'
        ? true
        : false
    const partNumber = data?.itemInfo?.[0]?.properties?.partnumber || ''
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      unitValue: unitValue,
      // totalValue: totalValue,
      totalValue: {
        originalPrice: parseFloat(originalPrice),
        priceAfterDiscount: parseFloat(priceAfterDiscount),
        priceFacets: priceFacets,
      },
    }
    let frequenciesBasedOnAdminConfig = getFrequenciesBasedOnAdminConfig({
      isMonthlyLabel: true,
    })
    let {
      frequencyPeriod = 1,
      frequencyType = 'MONTHS',
      type = 'VARIABLE_MULTI_ORDER',
    } = data

    let frequencyLabel = frequenciesBasedOnAdminConfig[0].label
    let isOneTime = false
    const frequencyValue = `${frequencyPeriod}-${frequencyType}`
    const subscriptionVal = frequenciesBasedOnAdminConfig.filter(
      item => frequencyValue == item.value
    )
    if (subscriptionVal.length) {
      if (subscriptionVal.length === 1) {
        frequencyLabel = subscriptionVal[0].label
      } else {
        if (type === 'VARIABLE_SINGLE_ORDER') {
          frequencyLabel = subscriptionVal[1].label
          isOneTime = subscriptionVal?.[1]?.isOneTime || false
        } else {
          frequencyLabel = subscriptionVal[0].label
        }
      }
    }
    const quantity = data?.itemInfo?.[0]?.quantity
    const isBundleOnly =
      bundleItems?.bundle?.[0]?.type?.toLowerCase() === 'bundle'
    let variantInfo = {}
    if (!isBundle) {
      const { variantLabel = '', variantColor = '' } = productInfo

      if (variantLabel) {
        variantInfo.isNormalSkuWithMultiVariant = true
        variantInfo.variantLabel = variantLabel
      }
    }
    const details = {
      productImage,
      pathUrl: url,
      productName: productInfo.name || '',
      skuId,
      partNumber,
      isStarterKit,
      priceObj,
      frequencyLabel,
      quantity,
      subTotal: totalValue?.priceAfterDiscount || '',
      type,
      subscriptionId: data?.id || '',
      isOneTime,
      processingDate: data.processingDate,
      isBundle: isBundleOnly,
      multiVariantEditSource: this.props.activeTab,
      bundleItems: bundleItems,
      variantInfo: variantInfo,
    }
    const monthText = getMonthStringList()[data.selectedMonth - 1]
    const selectedLabel = `${monthText} ${data.processingDate}`
    const isSkipped = data?.properties?.isSkipped === 'true' || false
    return (
      <div
        className={`product-list__product-card ${
          isOneTime && 'one-time-product'
        }`}>
        <div className="d-flex w-100">
          <div className="product-list-product-img">
            <LinkWithLocale
              to={{
                pathname: url || '',
              }}
              className={`prod-image-wrapper w-100`}>
              <ImageComponent
                width="100px"
                height="100px"
                optimizeImage={true}
                src={productImage || imagePlaceholder}
                alt={productInfo.name}
                className={`mw-100 mh-100 prod-img`}
                data-testid="qa-user-sub-product-image"
              />
            </LinkWithLocale>
          </div>
          <div
            className={`d-flex w-100 product-card-deatils-section ${
              data.isCurrentMonth && 'current-month'
            }`}>
            <div className="d-flex flex-column">
              <ProductDetails productData={details} {...this.props} />
              {data.isCurrentMonth && isSkipped && (
                <div className="skipped-section">
                  {i18nTranslate('subscriptions.skipped', 'skipped')}
                </div>
              )}
            </div>
            {data.isCurrentMonth && (
              <Button
                className="manage-next-button p-0 d-flex align-items-center justify-content-center"
                variant="outline-primary"
                onClick={() => this.handleManageOrder(selectedLabel)}
                data-testid="manage-next-button"
                tabIndex={0}>
                {i18nTranslate(
                  'subscriptions.manageNextOrder',
                  'Manage next order'
                )}
              </Button>
            )}
            {!data.isCurrentMonth && (
              <Button
                className="product-edit-button"
                variant="black"
                data-testid={'product-edit-button'}
                onClick={this.togglesSubscriptionModal}>
                <EditIcon aria-label={'product edit button'} />
              </Button>
            )}
            {this.showSubscriptionModal && (
              <SubscriptionModal
                show={this.showSubscriptionModal}
                onHide={this.togglesSubscriptionModal}
                productData={details}
                frequencyPeriod={frequencyPeriod}
                frequencyType={frequencyType}
                availableOrderDates={this.props?.availableOrderDates}
                handleDeleteItem={this.handleDeleteItem}
                {...this.props}
              />
            )}
            <DeleteItemModal
              show={this.confirmDeleteModal}
              onHide={this.handleDeleteClose}
              handleCancelItem={this.handleCancelItem}
              itemDetails={details}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ProductCard
export { ProductCard }
